import { Paper, styled } from "@mui/material";

const ThemedPaper = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
}));


export default ThemedPaper;